import { Row, Col } from "antd";
import React from "react";

import Tool from "./Tool";

//DEVICES
import screen from "../../images/tools/screen.jpg";
import keyboard from "../../images/tools/keyboard.jpg";
import mouse from "../../images/tools/mouse.jpg";
import pad from "../../images/tools/pad.jpg";
import micro from "../../images/tools/micro.jpg";
import bose from "../../images/tools/bose.jpg";

const Computer = props => {
  return (
    <React.Fragment>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={12}>
          <Tool
            title="Screen MSI 27 LED"
            description="Optix G27C"
            link="https://www.msi.com/Monitor/Optix-G27C"
            image={screen}
          />
        </Col>
        <Col span={12}>
          <Tool
            title="Keyboard Logitech"
            description="G413 Romer-G"
            link="https://www.logitechg.com/en-us/product/g413-mechanical-gaming-keyboard"
            image={keyboard}
          />
        </Col>
      </Row>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={12}>
          <Tool
            title="Mouse Logitech"
            description="G903"
            link="https://www.logitechg.com/en-us/product/g903-wireless-gaming-mouse"
            image={mouse}
          />
        </Col>
        <Col span={12}>
          <Tool
            title="Desk Pad"
            description="DX-1000 XXL"
            link="http://perixx.com/dx-1000.html"
            image={pad}
          />
        </Col>
      </Row>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={12}>
          <Tool
            title="Micro Bird UM1"
            description="USB"
            link="https://www.woodbrass.com/micros-usb-et-ipad-%20-iphone-bird-instruments-um1-p155970.html"
            image={micro}
          />
        </Col>
        <Col span={12}>
          <Tool
            title="Soundlink Bose"
            description="Mini 2"
            link="https://www.bose.com/en_us/products/speakers/portable_speakers/soundlink-mini-ii-bundle.html"
            image={bose}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Computer;



// WEBPACK FOOTER //
// ./src/components/Tools/Devices.js